import QuestionHelper from 'components/QuestionHelper'
import { Text } from 'rebass'

import {
  ModifiedBadge,
  PreviousValue,
  ReviewContent,
  ReviewItemHeader,
  ReviewItemLabel,
  ReviewItemWrapper,
} from './styled'

interface ReviewItemProps {
  label: string
  currentValue: string
  newValue: string
  info?: string
}

// eslint-disable-next-line react/prop-types
export const ReviewItem: React.FC<ReviewItemProps> = ({ label, currentValue, newValue, info }) => {
  const hasChanged = currentValue !== newValue

  return (
    <ReviewItemWrapper>
      <ReviewItemHeader>
        <ReviewItemLabel>
          {label}
          {info && <QuestionHelper text={info} />}
        </ReviewItemLabel>
        {hasChanged && <ModifiedBadge>Modified</ModifiedBadge>}
      </ReviewItemHeader>

      <ReviewContent>
        <Text fontSize="14px" fontWeight="600">
          {newValue}
        </Text>
        {hasChanged && <PreviousValue>Previous: {currentValue}</PreviousValue>}
      </ReviewContent>
    </ReviewItemWrapper>
  )
}
